import { LinkButton } from '../../../components/button/'
import InfoCard from '../../../components/info-card'

export default function Info() {
  return (
    <div className='cardContainer'>
      <InfoCard>
        <div className='imageContainer flex justifyCenter'>
          <img src='/images/operator.jpg' alt='operator' width='770' height='620' />
        </div>
        <aside>
          <h3>Get the help you need!</h3>
          <p>One of our friendly support staff are standing by to assist you.</p>

          <LinkButton href='/contact-us'>Give us a call</LinkButton>
        </aside>
      </InfoCard>

      <style jsx>{`
        .cardContainer {
          :global(a) {
            margin: 1.9rem 0 0;
          }
        }

        .imageContainer {
          max-width: 76.7rem;
          width: 100%;
          min-height: 62.3rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        aside {
          max-width: 65.3rem;
          padding: 12.4rem 4rem 6.8rem 7.5rem;
        }

        h3 {
          line-height: 4.3rem;
          font-size: 3.2rem;
        }

        p {
          margin: 1.9rem 0 1.9rem;
          line-height: 3rem;
          font-size: 2.2rem;
        }

        @media (max-width: 1024px) {
          .cardContainer {
            margin: auto;

            :global(a) {
              position: relative;
              left: 50%;
              transform: translateX(-50%);
              margin: 0;
            }
          }

          .imageContainer {
            max-width: 100%;
            min-height: unset;
          }

          aside {
            max-width: 100%;
            padding: 1.9rem 2.6rem 4.1rem;
          }

          h3 {
            margin: 0 0 1.1rem;
            line-height: 2rem;
            font-size: 1.4rem;
          }

          p {
            line-height: unset;
            font-size: 1.4rem;
          }
        }
      `}</style>
    </div>
  )
}
